import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, apiErr } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [ready, setReady] = useState(false);

  const [actAsUser, setActAsUserState] = useState(null);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        const isRootSession = r.data?.role === "root" || Boolean(r.data?.is_root_impersonating);
        if (!isRootSession) {
          localStorage.removeItem("ezjob_act_as");
          localStorage.removeItem("ezjob_act_as_info");
          setActAsUserState(null);
        } else if (r.data?.view_mode === "self") {
          localStorage.removeItem("ezjob_act_as");
          localStorage.removeItem("ezjob_act_as_info");
          setActAsUserState(null);
        } else if (r.data?.view_mode === "all") {
          const allObj = { id: "all", name: "See all (All Users)", role: "all" };
          localStorage.setItem("ezjob_act_as", "all");
          localStorage.setItem("ezjob_act_as_info", JSON.stringify(allObj));
          setActAsUserState(allObj);
        } else {
          const savedActAs = localStorage.getItem("ezjob_act_as_info");
          if (savedActAs) {
            try { setActAsUserState(JSON.parse(savedActAs)); } catch (e) {}
          }
        }
      })
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    localStorage.removeItem("ezjob_act_as");
    localStorage.removeItem("ezjob_act_as_info");
    localStorage.removeItem("ezjob_active_track_id");
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    setActAsUserState(null);
    return data.user;
  };

  const register = async (email, password, name) => {
    localStorage.removeItem("ezjob_act_as");
    localStorage.removeItem("ezjob_act_as_info");
    localStorage.removeItem("ezjob_active_track_id");
    const { data } = await api.post("/auth/register", { email, password, name });
    setToken(data.access_token);
    setUser(data.user);
    setActAsUserState(null);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setToken(null);
    localStorage.removeItem("ezjob_act_as");
    localStorage.removeItem("ezjob_act_as_info");
    localStorage.removeItem("ezjob_active_track_id");
    setActAsUserState(null);
    setUser(false);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const switchWorkspaceUser = (targetUser) => {
    localStorage.removeItem("ezjob_active_track_id");
    if (!targetUser) {
      localStorage.removeItem("ezjob_act_as");
      localStorage.removeItem("ezjob_act_as_info");
      setActAsUserState(null);
    } else {
      localStorage.setItem("ezjob_act_as", targetUser.id);
      localStorage.setItem("ezjob_act_as_info", JSON.stringify(targetUser));
      setActAsUserState(targetUser);
    }
    window.location.reload();
  };

  return (
    <AuthCtx.Provider value={{
      user,
      ready,
      actAsUser,
      switchWorkspaceUser,
      login,
      register,
      logout,
      refreshUser,
      apiErr,
    }}>

      {children}
    </AuthCtx.Provider>
  );
}
